// isdlAccessInstance.js
import { ISDLUrl, ISDLFunctionsKey } from './isdlData';
import { isTokenValid, refreshTokenSilently } from '../utils/AuthUtilities';
import { update_app_auth } from '../mobile/mobileHandler';
import { IsdlAccess } from 'isdlaccess'; // Adjust if necessary

const url = ISDLUrl();
const token = sessionStorage.getItem('authToken');
const apiKey = process.env.REACT_APP_API_KEY;
const funcKey = ISDLFunctionsKey();

const tokenValidator = (token) => {
  return isTokenValid(token);
};

const refreshTokenFn = async (currentToken) => {
  let newToken = await refreshTokenSilently();
  return newToken;
};

const isdlAccessInstance = new IsdlAccess(
  url,
  token,
  apiKey,
  funcKey,
  tokenValidator,
  refreshTokenFn
);

isdlAccessInstance.addAppAuthListener((newToken, newApiKey) => {
  update_app_auth(newToken, newApiKey, ISDLUrl(), ISDLFunctionsKey());
});

// Export using ES module syntax
export default isdlAccessInstance;